import { createAsyncThunk } from "@reduxjs/toolkit";

import { updateDeploymentSettingsRequest } from "Api/organizations/projects/updateDeploymentSetting.request";
import logger from "Libs/logger";
import { isJson } from "Libs/utils";

import type {
  UpdateDeploymentSettingsProps,
  DeploymentSettings
} from "../types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateDeploymentSettings = createAsyncThunk<
  DeploymentSettings,
  UpdateDeploymentSettingsProps,
  AsyncThunkOptionType
>(
  "app/environmentDeploymentSettings/update",
  async (
    { projectId, environmentId, manualDeploymentsEnabled },
    { rejectWithValue }
  ) => {
    try {
      const updatedDeploymentSettings = await updateDeploymentSettingsRequest({
        projectId,
        environmentId,
        manualDeploymentsEnabled
      });

      return updatedDeploymentSettings?._embedded?.entity;
    } catch (error) {
      const errorMessage = isJson(error)
        ? error
        : "An error occurred while attempting to update deployment settings.";
      logger(errorMessage, {
        action: "update_deployment_settings"
      });

      return rejectWithValue(error as { code: number; message: string });
    }
  }
);
